<div class="route-cont {{animation}} animated show">
  <div class="main-image" #mainImage>
    <app-carousel
      [showDots]="true"
      [styleDots]="styleDots"
      [autoMoveItems]="true"
      [positionDots]="positionDots"
      [positionSpaceMedium]="true">
      <div content class="img-cont"
        *ngFor="let image of [].constructor(quantityImagesFlight); index as id;"
        [id]="id">
        <app-image
          [type]="typeImageFlight"
          [src]="getImageSrc(id)"
          [borderRadius]="borderRadius"
          [borderTopLeftRadius]="borderRadiusNone"
          [borderTopRightRadius]="borderRadiusNone"
          [dimension]="'443x'"
          [maxHeight]="220">
        </app-image>
      </div>
    </app-carousel>
    <div class="gradient"></div>
  </div>
  <div class="body"
    (scroll)="onScroll($event)">
    <div class="body--container">
      <span class="back-button">
        <app-ds-header
          [widgetConfig]="[
          {
            Type: headerWidgetType.Back,
          },
        ]"
        [isTransparent]="true"
        (clickAction)="close()">
      </app-ds-header>
      </span>
      <div class="box-header">
        <div class="title">{{ airplane }}</div>
        <div class="info">{{ airlineName | airlineName }}</div>
      </div>
      <div class="box-content--list">
        <div class="box-content"
        #description
        *ngIf="showDescription">
          <div class="title">
            {{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.TITLE_DESCRIPTION' | transloco }}
          </div>
          <div class="content description">
            <p>{{cabin.CabinClass.Description}}</p>
          </div>
        </div>
        <div class="box-content"
          #amenities
          *ngIf="showAmenities">
          <div class="title">
            {{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.TITLE_AMENITIES' | transloco }}
          </div>
          <div class="content amenities">
            <div class="amenitie-item"
              *ngIf="cabin.Entertainment.Available">
              <div class="amenitie-item--icon">
                <app-ds-icon
                  [icon]="icons.InFlightEntertainment"
                  [size]="24"
                  [color]="iconFillColor.Primary">
                </app-ds-icon>
              </div>
              <div class="amenitie-item--container">
                <div class="amenitie-item--title">
                  {{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.ENTERTAINMENT.TITLE' | transloco }}
                </div>
                <div class="amenitie-item--body">
                  <p>{{ cabin.Entertainment.Description}}</p>
                  <p class="amenitie-item--info">
                    {{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.ENTERTAINMENT.TITLE_TYPES' | transloco }}<br/>
                    <strong>{{ getEntertainmentTypes(cabin.Entertainment.Type) }}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div class="amenitie-item"
              *ngIf="cabin.Power.Available">
              <div class="amenitie-item--icon">
                <app-ds-icon
                  [icon]="icons.Power"
                  [size]="24"
                  [color]="iconFillColor.Primary">
                </app-ds-icon>
              </div>
              <div class="amenitie-item--container">
                <div class="amenitie-item--title">{{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.POWER.TITLE' | transloco }}</div>
                <div class="amenitie-item--body">
                  <p>{{ cabin.Power.Description }}</p>
                  <p class="amenitie-item--info">
                    {{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.POWER.TITLE_TYPE' | transloco }}<br/>
                    <strong>{{ cabin.Power.Type }}</strong>
                  </p>
                  <p class="amenitie-item--info">
                    {{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.POWER.TITLE_USB' | transloco }}<br/>
                    <strong>{{ cabin.Power.USBAvailable }}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div class="amenitie-item"
              *ngIf="cabin.Wifi.Available">
              <div class="amenitie-item--icon">
                <app-ds-icon
                  [icon]="icons.Wifi"
                  [size]="24"
                  [color]="iconFillColor.Primary">
                </app-ds-icon>
              </div>
              <div class="amenitie-item--container">
                <div class="amenitie-item--title">{{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.WIFI.TITLE' | transloco }}</div>
                <div class="amenitie-item--body">
                  <p>{{ cabin.Wifi.Description }}</p>
                  <p class="amenitie-item--info"
                    *ngIf="showWithCharge">
                    {{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.WIFI.TITLE_COST' | transloco }}<br/>
                    <strong>{{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.WIFI.WITH_CHARGE' | transloco }}</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box-content"
          #seats
          *ngIf="showSeats">
          <div class="title">
            {{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.SEATS.TITLE' | transloco }}
            <span class="additional">{{cabin.Seats.Type}}</span>
          </div>
          <div class="content seats">
            <div class="seat-item">
              <div class="seat-item--icon">
                <app-ds-icon
                  [icon]="icons.SeatPitch"
                  [size]="22"
                  [color]="iconFillColor.Primary">
                </app-ds-icon>
              </div>
              <div class="seat-item--title">{{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.SEATS.DISTANCE' | transloco }}</div>
              <div class="seat-item--value">{{cabin.Seats.DistanceBetweenSeats}} cm</div>
            </div>
            <div class="seat-item">
              <div class="seat-item--icon">
                <app-ds-icon
                  [icon]="icons.SeatWidth"
                  [size]="22"
                  [color]="iconFillColor.Primary">
                </app-ds-icon>
              </div>
              <div class="seat-item--title">{{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.SEATS.WIDTH' | transloco }}</div>
              <div class="seat-item--value">{{cabin.Seats.Width}} cm</div>
            </div>
            <div class="seat-item">
              <div class="seat-item--icon">
                <app-ds-icon
                  [icon]="icons.SeatInclination"
                  [size]="22"
                  [color]="iconFillColor.Primary">
                </app-ds-icon>
              </div>
              <div class="seat-item--title">{{ 'FLIGHT_ITEM_DETAIL_MODULE.CABIN.SEATS.PITCH' | transloco }}</div>
              <div class="seat-item--value">{{cabin.Seats.Pitch}}&deg;</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
